var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdvancedSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1667 3.33325H18.1667M11.5 13.3333L16.5 18.3333L11.5 13.3333ZM7.33333 14.9999C8.09938 14.9999 8.85792 14.849 9.56565 14.5559C10.2734 14.2627 10.9164 13.8331 11.4581 13.2914C11.9998 12.7497 12.4295 12.1066 12.7226 11.3989C13.0158 10.6912 13.1667 9.93263 13.1667 9.16659C13.1667 8.40054 13.0158 7.642 12.7226 6.93427C12.4295 6.22653 11.9998 5.58347 11.4581 5.0418C10.9164 4.50012 10.2734 4.07044 9.56565 3.77729C8.85792 3.48414 8.09938 3.33325 7.33333 3.33325C5.78624 3.33325 4.30251 3.94783 3.20854 5.0418C2.11458 6.13576 1.5 7.61949 1.5 9.16659C1.5 10.7137 2.11458 12.1974 3.20854 13.2914C4.30251 14.3853 5.78624 14.9999 7.33333 14.9999V14.9999ZM15.6667 0.833252V5.83325V0.833252Z",
    stroke: "#DC9023",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvancedSearch);
export default __webpack_public_path__ + "static/media/AdvancedSearch.9bbd4ee8.svg";
export { ForwardRef as ReactComponent };